<template>
  <el-dialog :title="title" append-to-body :close-on-click-modal="false" :visible="visible" width="80%"
    :before-close="closeDialog">
    <div>
      <el-form label-width="100" :inline="true">
        <el-form-item label="点检时间">
          <el-date-picker
              v-model="month"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM"
              placeholder="选择月"
              @change="getMockData">
          </el-date-picker>
        </el-form-item>
        <el-button size="medium" type="primary" @click="getMockData">查看</el-button>
        <el-button @click="downExcel">导出</el-button>
      </el-form>
    </div>
    <el-table border style="width: 100%" :data="tableData" align="center">
      <el-table-column width="35" label="序号" type="index"></el-table-column>
      <el-table-column prop="title" label="项目"></el-table-column>
      <el-table-column prop="cycle" label="点检周期"></el-table-column>
      <el-table-column prop="standard" label="点检标准"></el-table-column>
      <el-table-column align="center" width="30" label="1">
        <template slot-scope="scope">
          <span>{{ scope.row.days[1] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="2">
        <template slot-scope="scope">
          <span>{{ scope.row.days[2] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="3">
        <template slot-scope="scope">
          <span>{{ scope.row.days[3] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="4">
        <template slot-scope="scope">
          <span>{{ scope.row.days[4] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="5">
        <template slot-scope="scope">
          <span>{{ scope.row.days[5] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="6">
        <template slot-scope="scope">
          <span>{{ scope.row.days[6] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="7">
        <template slot-scope="scope">
          <span>{{ scope.row.days[7] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="8">
        <template slot-scope="scope">
          <span>{{ scope.row.days[8] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="9">
        <template slot-scope="scope">
          <span>{{ scope.row.days[9] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="10">
        <template slot-scope="scope">
          <span>{{ scope.row.days[10] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="11">
        <template slot-scope="scope">
          <span>{{ scope.row.days[11] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="12">
        <template slot-scope="scope">
          <span>{{ scope.row.days[12] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="13">
        <template slot-scope="scope">
          <span>{{ scope.row.days[13] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="14">
        <template slot-scope="scope">
          <span>{{ scope.row.days[14] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="15">
        <template slot-scope="scope">
          <span>{{ scope.row.days[15] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="16">
        <template slot-scope="scope">
          <span>{{ scope.row.days[16] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="17">
        <template slot-scope="scope">
          <span>{{ scope.row.days[17] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="18">
        <template slot-scope="scope">
          <span>{{ scope.row.days[18] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="19">
        <template slot-scope="scope">
          <span>{{ scope.row.days[19] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="20">
        <template slot-scope="scope">
          <span>{{ scope.row.days[20] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="21">
        <template slot-scope="scope">
          <span>{{ scope.row.days[21] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="22">
        <template slot-scope="scope">
          <span>{{ scope.row.days[22] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="23">
        <template slot-scope="scope">
          <span>{{ scope.row.days[23] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="24">
        <template slot-scope="scope">
          <span>{{ scope.row.days[24] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="25">
        <template slot-scope="scope">
          <span>{{ scope.row.days[25] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="26">
        <template slot-scope="scope">
          <span>{{ scope.row.days[26] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="27">
        <template slot-scope="scope">
          <span>{{ scope.row.days[27] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="28">
        <template slot-scope="scope">
          <span>{{ scope.row.days[28] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="29">
        <template slot-scope="scope">
          <span>{{ scope.row.days[29] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="30">
        <template slot-scope="scope">
          <span>{{ scope.row.days[30] }}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" width="30" label="31">
        <template slot-scope="scope">
          <span>{{ scope.row.days[31] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>
<script>
import { downloadExcel, inspectionFormData } from '@/api/ryt.js'
import { baseUrl } from "@/utils/index";

export default {
  components: {
  },
  data() {
    return {
      visible: false,
      title: '',
      pageId: '',
      month: '',
      tableData: []
    }
  },
  methods: {
    openDialog(row) {
      if (row) {
        this.pageId = row.id
        this.title = row.title + '：点检表'
        this.visible = true
        this.tableData = []
        this.month = this.getCurrentYearMonth()
        this.getMockData()
      }
    },
// 在Vue的methods中
    getCurrentYearMonth() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth() + 1
      const month = currentMonth>10?currentMonth:'0'+currentMonth;
      return currentDate.getFullYear() + '-' + month;
    },

    // 根据当前月获取
    getMockData() {
      var that = this;
      inspectionFormData({month:that.month,pageId:that.pageId}).then((res) => {
        this.tableData = res
        console.log(res)
      });
    },
    closeDialog() {
      this.visible = false
    },
    downExcel(){
      var that = this;
      downloadExcel({month:that.month,pageId:that.pageId}).then((res) => {
        let urls = baseUrl + res;
        const link = document.createElement("a");
        link.href = urls;
        link.style.display = "none";
        link.download = "抛丸车间点检表-"+that.month+".xlsx"; // 设置下载的文件名
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message({
          type: "success",
          message: "导出成功",
        });
        that.printVisible = false
      });
    }
  }
}
</script>
